import React from "react";
import FHAFamily from "../../PicesForPages/FHA_family2.png";
import FreeConsultation from "../Form/FreeConsultation";
import { Link } from "react-router-dom";

function FHA() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent FHALoansTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={FHAFamily}
          alt="FHAFamilyImage"
          className="background-video FHA_FamilyImage"
        />
        <div className="purchasetopBox FHALoansTopBox">
          {/* The existing Purchase span */}
          <span>FHA Loans</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              Since 1934, FHA loans have assisted people in becoming homeowners.
            </span>
            <span className="purchaseBottomLeftHeader">
              Some of the advantages of FHA loans include:
            </span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>Minimal down payments</li>
              <li>Lower closing costs</li>
              <li>Easier credit qualifications</li>
            </ul>
            <span className="purchaseBottomLeftHeader">
              What Can FHA Offer You?
            </span>
            <span className="purchaseBottomLeftSubHeader">
              First-Time Homebuyers
            </span>
            <span className="purchaseBottomLeftContent">
              If you're buying your first home, an FHA loan might be the perfect
              solution. With a down payment as low as 3.5% of the purchase
              price, you can also roll most of your closing costs and fees into
              the loan. This option is available for properties with 1 to 4
              units.
            </span>

            <span className="purchaseBottomLeftSubHeader">
              Fixer-Upper Enthusiasts
            </span>
            <span className="purchaseBottomLeftContent">
              For those interested in a fixer-upper, FHA offers a loan that lets
              you purchase a home, renovate it, and consolidate all costs into a
              single loan. Homeowners looking to remodel or repair can refinance
              their current loan and include the renovation costs in one
              package.
            </span>

            <span className="purchaseBottomLeftSubHeader">
              Financial Assistance for Seniors
            </span>
            <span className="purchaseBottomLeftContent">
              If you're 62 or older, live in your home, and own it outright or
              have a small loan balance, the FHA Reverse Mortgage could be
              suitable for you. This allows you to convert a portion of your
              home equity into cash.
            </span>

            <span className="purchaseBottomLeftSubHeader">
              Energy-Efficient Upgrades
            </span>
            <span className="purchaseBottomLeftContent">
              FHA provides an Energy-Efficient Mortgage that lets you
              incorporate the costs of energy-saving improvements into your
              loan.
            </span>

            <span className="purchaseBottomLeftSubHeader">
              Manufactured and Mobile Homes
            </span>
            <span className="purchaseBottomLeftContent">
              FHA also finances mobile homes and factory-built housing, offering
              two loan options: one for landowners and another for mobile homes
              located in parks.
            </span>

            <span className="purchaseBottomLeftHeader">How FHA Loans Work</span>
            <span className="purchaseBottomLeftContent">
              Since 1934, the FHA, a part of HUD, has insured loans, enabling
              lenders to offer more favorable terms. FHA loans allow purchases
              with as little as a 3.5% down payment and have more flexible
              requirements regarding credit, funds to close, and co-borrowers.
            </span>

            <span className="purchaseBottomLeftHeader">
              Credit Considerations
            </span>
            <span className="purchaseBottomLeftContent">
              FHA loans don't have strict credit score requirements, unlike many
              conventional loans. Even with a low credit score, borrowers can
              still qualify if they demonstrate their ability to repay the loan.
              The underwriter reviews the most recent 12-24 months of credit
              history, and even those with past issues might get approved if
              their recent payment history is solid.
            </span>

            <span className="purchaseBottomLeftHeader">
              Cost and Payment Details
            </span>
            <span className="purchaseBottomLeftContent">
              FHA loans require a minimum of 3.5% of the sales price for the
              down payment, but total closing costs may range between 6% and 8%
              of the sales price, including escrows for taxes and insurance.
              Interest rates can also affect total costs, with options to trade
              lower rates for higher initial costs or vice versa.
            </span>

            <span className="purchaseBottomLeftHeader">Funding Sources</span>
            <span className="purchaseBottomLeftContent">
              Borrowers can use personal savings, gifts, grants, retirement
              account loans, and seller contributions to cover the necessary
              funds for closing.
            </span>

            <div className="purchaseBottomLeftButton">
              <Link
                to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                className="purchaseBottomLeftButtonLink"
              >
                APPLY!
              </Link>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default FHA;
